export function init() {
	const button = document.querySelectorAll('.js-supercontrol-book');
	if (!button) {
		return;
	}

	button.forEach(el => el.addEventListener('click', (event) => {
		event.preventDefault();
		let cartDetailsJson = event.target.getAttribute('data-booking-data');
		let cartDetailsObj = JSON.parse(cartDetailsJson);
		window.postMessage(cartDetailsObj, '*');
	}));
}
